import PageLoadAnimation from "../page-load-animation";

class AsyncForm {
    constructor() {
        this._init()
    }

    _init() {
        const pageLoadAnimation = new PageLoadAnimation(false);
        document.querySelectorAll('[data-async-form]').forEach(elForm => {
            new AsyncFormItem(elForm, pageLoadAnimation)
        });

        document.querySelectorAll('[data-async-form-post]').forEach(elForm => {
            new AsyncFormPost(elForm, pageLoadAnimation)
        });
    }
}

class AsyncFormItem {
    constructor(el, pageLoadAnimation) {
        this.el = el;
        this.pageLoadAnimation = pageLoadAnimation;
        this._init();
    }

    _init() {
        this.el.addEventListener('submit', (event) => {
            // Check if the event is triggered by a form
            if (event.target && event.target.matches('form')) {
                event.preventDefault(); // Prevent default form submission

                this.pageLoadAnimation.toggleLoading(true);

                const formData = new FormData(event.target);
                const searchParams = new URLSearchParams();

                for (const pair of formData) {
                    searchParams.append(pair[0], pair[1]);
                }

                fetch(event.target.getAttribute('data-action'), {
                    method: event.target.getAttribute('method'),
                    body: searchParams,
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    }
                })
                    .then(response => response.text())
                    .then(data => {
                        this.el.innerHTML = data; // Replace the form with the new form from the response
                        this.pageLoadAnimation.toggleLoading(false);
                    })
                    .catch(error => {
                        console.error('Error:', error);
                        this.pageLoadAnimation.toggleLoading(false);
                    });
            }
        });
    }
}

class AsyncFormPost {
    constructor(el, pageLoadAnimation) {
        this.el = el;
        this.pageLoadAnimation = pageLoadAnimation;
        this._init();
    }

    _init() {
        this.el.addEventListener('submit', (event) => {

            // ignore if has data-ignore defined in event target
            if (event.target && event.target.matches('[data-ignore]')) {
                return;
            }

            // Check if the event is triggered by a form
            if (event.target && event.target.matches('form')) {
                event.preventDefault(); // Prevent default form submission

                this.pageLoadAnimation.toggleLoading(true);

                const formData = new FormData(event.target);
                // Check if the event has a 'submitter' property (the button that triggered the form submission)
                // This is available in modern browsers
                if (event.submitter) {
                    formData.append(event.submitter.name, event.submitter.value);
                }

                fetch(event.target.getAttribute('data-action'), {
                    method: event.target.getAttribute('method'),
                    body: formData,
                })
                    .then((response) => {
                        return response.text();
                    })
                    .then(data => {
                        this.el.innerHTML = data; // Replace the form with the new form from the response
                        this.pageLoadAnimation.toggleLoading(false);
                    })
                    .catch(error => {
                        console.error('Error:', error);
                        this.pageLoadAnimation.toggleLoading(false);
                    });
            }
        });
    }
}

export default AsyncForm